var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"height100"},[_c('renewal-dashboard-window')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }